@if (isVisible) {
  <comat-fab-speed-dial
    id="addNewInspectionIcon"
    [actions]="speedDialActions"
    (selectedAction)="onFabSpeedDialSelectedAction($event)"
    mainIcon="add"
    color="accent"
  >
  </comat-fab-speed-dial>
} @else {
  <div class="add-inspection-loader">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}
